import { View, Text, Animated, StyleSheet } from "react-native";
import React, { useRef, useEffect, useState } from "react";

export default function Fade(props) {
  const { duration, isShown, heightw } = props;
  const [height, setHeight] = useState(0);

  const fadeAnim = useRef(new Animated.Value(0)).current;
  const fadeIn = () => {
    // Will change fadeAnim value to 1 in 5 seconds
    Animated.timing(fadeAnim, {
      toValue: height,
      duration: duration,
      useNativeDriver: false,
    }).start();
  };

  const fadeOut = () => {
    Animated.timing(fadeAnim, {
      toValue: 0,
      duration: duration,
      useNativeDriver: false,
    }).start();
  };
  if (isShown === true) {
    fadeIn();
  } else {
    fadeOut();
  }

  return (
    <Animated.View
      style={[
        styles.fading,
        props.style,
        {
          height: fadeAnim,
        },
      ]}
    >
      <View style={{ height: 200, width: "100%" }}>
        <View
          style={{ width: "100%", alignItems: "center" }}
          onLayout={(event) => {
            let { height } = event.nativeEvent.layout;
            setHeight(height);
          }}
        >
          {props.children}
        </View>
      </View>
    </Animated.View>
  );
}
const styles = StyleSheet.create({
  fading: {
    overflow: "hidden",
    width: "100%",
    alignItems: "center",
  },
});
